import { render, staticRenderFns } from "./scholar.vue?vue&type=template&id=21232004&scoped=true"
import script from "./scholar.vue?vue&type=script&lang=js"
export * from "./scholar.vue?vue&type=script&lang=js"
import style0 from "./scholar.vue?vue&type=style&index=0&id=21232004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21232004",
  null
  
)

export default component.exports